const Coupon = () => import('@/modules/coupon/index.vue');
import checkPermission from '@/modules/coupons/_routes/checkPermission';

export default [
  {
    path: '/cupons/editar/:id',
    name: 'coupon-edit',
    component: Coupon,
    props: true,
    beforeEnter: checkPermission,
    meta:{
      navbarTitle: 'Criar cupom',
    },
  },
  {
    path: '/franquia/cupons/editar/:id',
    name: 'franchise-coupon-edit',
    component: Coupon,
    props: true,
    beforeEnter: checkPermission,
    meta:{
      navbarTitle: 'Editar cupom',
    },
  },
];
